import React from 'react';
import { SIGN_IN_PATH } from '@apps/config/constant';
import { useNavigationItems } from '@apps/config/navigation.config';
import { useUserDropdownMenuItems } from '@apps/config/user-dropdown.config';
import { Box } from '@mui/material';
import { KPSBCareLogoIcon } from '@stack/assets/icons';
import { SettingSlug, useSettingDetailQuery } from '@stack/data-access-clinic';
import { MainLayout } from '@webbyx/mui';
import { clearAuthToken, redirect, useAuthIdentity } from '@webbyx/next-js';
import Image from 'next/image';

import ContactUs from './ContactUs';
import { LayoutProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const Layout: React.FC<LayoutProps> = (props) => {
  const { contentHeightFixed, children } = props;

  // =============== HOOKS
  const { authUser, config } = useAuthIdentity();
  const menuItems = useNavigationItems();
  const userItems = useUserDropdownMenuItems({
    onLogout: () => {
      clearAuthToken();
      redirect({}, SIGN_IN_PATH, 'replace');
    },
  });
  const { data } = useSettingDetailQuery({
    variables: { setting_slug: SettingSlug.HotlineNumber },
  });

  // =============== VIEWS
  if (config?.shouldHideLayout) {
    return <>{children}</>;
  }

  return (
    <MainLayout
      company="ABC"
      brandingLink="/"
      enableFixedContentHeight={contentHeightFixed}
      verticalLayoutProps={{
        navigation: {
          items: menuItems,
          afterContent: () => (
            <ContactUs hotline={data?.SettingDetail?.setting_value ?? ''} />
          ),
        },
        appBar: {
          rightItems: [
            {
              type: 'language',
              props: {
                options: [
                  { label: 'English', value: 'en' },
                  { label: 'Bahasa Melayu', value: 'ms' },
                ],
              },
            },
            {
              type: 'user',
              props: {
                type: 'icon',
                avatar: authUser?.clinic?.clinic_logo ? (
                  <Image
                    src={authUser?.clinic?.clinic_logo ?? ''}
                    alt="avatar"
                    width={40}
                    height={40}
                    style={{ borderRadius: '50%' }}
                    unoptimized
                  />
                ) : // <></>
                null,
                name: authUser?.user_fullname ?? undefined,
                role: authUser?.clinic?.clinic_name ?? '',
                color: 'primary',
              },
              items: userItems,
            },
          ],
        },
      }}
      branding={(options) => {
        const collapsed = options?.navCollapsed && !options?.isSiderHovered;
        return (
          <Box
            sx={{
              transition: 'all 0.25s',
              ...(!collapsed
                ? { paddingTop: '1rem', paddingX: '1rem', width: '100%' }
                : { paddingTop: '1rem', width: 45 }),
            }}
          >
            <KPSBCareLogoIcon width="100%" />
          </Box>
        );
      }}
    >
      {children}
    </MainLayout>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export default Layout;
